import React, { useState, useEffect } from "react";
 
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Autocomplete,
  Chip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import { updateLoamReviewer, changeInvoiceStatus, getUsersByRole } from "../../actions";
import jwt from "jsonwebtoken";
import CloseIcon from "@material-ui/icons/Close";
import getParameterByName from "../../../../Functions/functions";

const useStyles = makeStyles(dashboardStyle);
 
const ReviewerModal = ({
  open,
  close,
  Invoice_Id,
  setSuccessMessage,
  setErrorMessage,
  setLoading,
  loading,
  newFormState,
  setNewFormState,
  statusForpayload,
  setStatusForPayload,
  setAllowToProceed
}) => {
  console.log(Invoice_Id)
  const classes = useStyles();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    Invoice_Id: Invoice_Id,
    IRUser: "",
  });
  const [filterloginUser, setFilterLoginUser] = useState([]);
  const [userData, setUserData] = useState([]);
  const [Filter, setfilter] = useState([]);
  const [filteredUserData,setFilteredUserData ]= useState([]);

  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
 
  const getUsers = async () => {
    getUsersByRole("Reviewer", setUserData, setLoading);
  };
  useEffect(() => {
    getUsers();
  }, []);
 
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  console.log(newFormState)
  const roleName = getParameterByName("roleName");

  useEffect(()=>{
    const selectedUserIds = newFormState?.loamReviewer;
    const newFilteredData = userData?.filter(user => !selectedUserIds?.includes(user?.userId));
    setFilteredUserData(newFilteredData);
  },[newFormState])

  useEffect(()=>{
    setFilteredUserData(userData)
  },[userData])

  useEffect(()=>{
    setNewFormState((newFormState) => ({
      ...newFormState,
      loamReviewer: [],
    }));
  },[])
 
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
      state:roleName=='IR'?'SendToReviewerFromIR':'SendToReviewerFromIP'
    }));
    setStatusForPayload(formState.state)
  };
  const submitHandler = (e) => {
    e.preventDefault();
        changeInvoiceStatus(
            newFormState.invoice_Id==0?Invoice_Id:newFormState.invoice_Id,
            roleName=='IR'||!Invoice_Id?'SendToReviewerFromIR':'SendToReviewerFromIP',
          "",
          "",
          "",
          "",
          "",
          newFormState.comments,
          newFormState.aditional_Comments,
          ""
        );
    updateLoamReviewer(
      Invoice_Id,
      newFormState,
      setSuccessMessage,
      setErrorMessage,
      setLoading,
      close,
      navigate,
      setAllowToProceed
    );
  };
  
  return (
    <Dialog open={open} onClose={close} fullWidth>
      <form onSubmit={submitHandler}>
        <DialogTitle>
          <Typography>
           Reviewers<span className={classes.asterisk}>*</span>
          </Typography>
        </DialogTitle>
        <div></div>
        <DialogContent>
          {/* <Typography>
            Tax Team<span className={classes.asterisk}>*</span>
          </Typography> */}
  <Autocomplete
  sx={{
    "& .MuiInputBase-root": {
      height: (newFormState.loamReviewer?.length || 0) === 0 ? "30px" : "auto",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      marginTop: "-4px",
      fontSize: 15,
    },
  }}
  multiple
  options={filteredUserData || []} // Ensure options is never undefined
  getOptionLabel={(option) => option.userName}
  getOptionDisabled={(option) =>
    newFormState?.loamReviewer?.includes(option?.userId) || false
  }
  value={newFormState?.loamReviewer!=="" && newFormState?.loamReviewer?.map((reviewerId) =>
    userData?.find((user) => user.userId === reviewerId)
  ) || []}
  loading={loading}
  onChange={(event, newValue) => {
    setNewFormState((prevFormState) => ({
      ...prevFormState,
      loamReviewer: newValue?.map(user => user?.userId) || [],
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      size="small"
      fullWidth
      placeholder={
        (newFormState.loamReviewer?.length || 0) === 0
          ? "Select Reviewers"
          : ""
      }
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <>
            {loading ? (
              <CircularProgress
                color="inherit"
                size={20}
              />
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
      }}
    />
  )}
  renderTags={(value, getTagProps) =>
    value.map((option, index) => (
      <Chip
        key={index}
        label={option?.userName}
        onDelete={() => {
          const updatedReviewers = newFormState?.loamReviewer?.filter(
            userId => userId !== option.userId
          ) || [];
          setNewFormState((prevFormState) => ({
            ...prevFormState,
            loamReviewer: updatedReviewers,
          }));
        }}
        deleteIcon={<CloseIcon />}
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#e0e0e0",
          padding: "2px",
          marginRight: "4px",
        }}
        {...getTagProps({ index })}
      />
    ))
  }
/>
          {/* <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-name-label">Select Tax Team</InputLabel>
            <Select
              labelId="demo-simple-name-label"
              id="demo-simple-name"
              label="Select Tax Team"
              name="taxTeam"
              value={formState.taxTeam}
              onChange={changeHandler}
              MenuProps={MenuProps}
            >
              {!loading ? (
                userData.length > 0 ? (
                  userData
                    ?.filter((item) => {
                      return item.userId != user?.LoginId;
                    })
                    .map((item, index) => (
                      <MenuItem key={index} value={item.userId}>
                        {item.userName}
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem disabled>Not Found</MenuItem>
                )
              ) : (
                <MenuItem>
                  <CircularProgress size={24} />
                </MenuItem>
              )}
            </Select>
          </FormControl> */}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={close}>
            Close
          </Button>
          <Button color="secondary" variant="contained" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
 
export default ReviewerModal;



